import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthStrategyFactory } from './auth-strategy.factory';
import { 
    IAuthCredentials, 
    IAuthResponse, 
    AuthType 
} from '../../models/auth.models';
import { LoggerService } from '../logger.service';
import { SecurityService } from '../security.service';

/**
 * Servicio mejorado de autenticación
 * Coordina las diferentes estrategias de autenticación
 * Implementa el patrón Facade para simplificar la interfaz
 */
@Injectable({
    providedIn: 'root'
})
export class EnhancedAuthService {
    constructor(
        private authStrategyFactory: AuthStrategyFactory,
        private securityService: SecurityService,
        private logger: LoggerService
    ) {}

    /**
     * Autentica al usuario usando la estrategia apropiada
     * @param credentials - Credenciales de autenticación
     * @returns Observable con la respuesta de autenticación
     */
    login(credentials: IAuthCredentials): Observable<IAuthResponse> {
        const strategy = this.authStrategyFactory.createStrategy(credentials.authType);

        return strategy.authenticate(credentials).pipe(
            map(response => {
                if (response.jwt) {
                    this.securityService.storeSession(response);

                    if (response.mfaRequired !== undefined) {
                        this.securityService.isPinValidated(response.mfaRequired !== true);
                    }
                }
                
                return response;
            }),
            catchError(error => {
                throw error;
            })
        );
    }

    /**
     * Cierra la sesión del usuario
     */
    logout(): void {
        this.securityService.logout();
    }
}
